import ModalProps from './ModalProps';
export interface ListRFIProps {
  filter: FilterProps
  listRfiProps: ModalProps,
}
export interface ListRFIByDepartmentProps extends ModalProps {
  departments: KeyProps;
}
export interface FilterProps {
  filterBy: string;
  date: string;
  dateEnd: string;
  tenantId: number;
}
  
export interface KeyProps {
  [key: string]: string
}

export interface LineChartDataset {
  label: string;
  [key: string]: number | string;
}

export interface LineChartObjectByStatus {
  rfi_status: string;
  count: number;
}
export interface LineChartObjectByDepartment {
  rfi_department_name: string;
  count: number;
}
export interface DataFromApiObject {
  label: string;
}
export interface StatusObject extends DataFromApiObject {
  data: LineChartObjectByStatus[];
}
export interface DepartmentObject extends DataFromApiObject {
  data: LineChartObjectByDepartment[];
}

export interface ReportLineChartProps {
  reportsDataList: LineChartDataset[],
  keyToLabel: KeyProps,
  colors: KeyProps,
}

export interface RFIByStatusColorType {
  [key: string]: string;
  Pending: string;
  Responded: string;
  Viewed: string;
  Closed: string;
}

export enum ReportFilters {
  STATUS = 'Status',
  DEPARTMENT = 'by Department',
}